import { DatePicker, Form, Input } from "antd";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { GeneralFormProvider } from "components/UI/GeneralForm/GeneralFormProvider";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { CommissionGroupSelectSearchable } from "components/UI/Selects/CommissionGroupSelectSearchable/CommissionGroupSelectSearchable.tsx";
import { RequestStatusSelectSearchable } from "components/UI/Selects/RequestStatusSelectSearchable/RequestStatusSelectSearchable.tsx";
import dayjs from "dayjs";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";

import { AffiliateOfferFormData, schema } from "./formSchema";

import UserRequestData = App.Data.UserRequestData;
import OfferData = App.Data.OfferData;

interface AffiliateOfferDetailFormProps {
    request: UserRequestData;
}

const AffiliateOfferDetailFormContent: FC<AffiliateOfferDetailFormProps> = ({ request }) => {
    const { t } = usePaldockTranslation("forms.affiliate-offer-detail");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm<AffiliateOfferFormData>();
    const { control, fieldNames } = generalFormUtils;

    return (
        <DrawerContent>
            <Form layout="vertical">
                {/* TODO: form section title + collapsible? */}
                <div className="grid rounded-lg grid-cols-2 gap-x-4 gap-y-0 p-4 bg-white m-3">
                    <FormItem control={control} name={fieldNames.title.name} label={tFields("offer.label")}>
                        <Input disabled readOnly />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.email.name} label={t("fields.affiliate_email.label")}>
                        <Input disabled readOnly value={request.user?.email || ""} />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.status.name} label={tFields("status.label")}>
                        <RequestStatusSelectSearchable value={request.status} disabled />
                    </FormItem>
                    <FormItem control={control} name="commission_group_id" label={tFields("commission_group.label")}>
                        <CommissionGroupSelectSearchable disabled />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.created_at.name} label={tFields("created_at.label")}>
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={dayjs(request.created_at)}
                            disabled
                            className={"w-full"}
                        />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.updated_at.name} label={tFields("updated_at.label")}>
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={dayjs(request.updated_at)}
                            disabled
                            className={"w-full"}
                        />
                    </FormItem>
                </div>
            </Form>
        </DrawerContent>
    );
};

export const AffiliateOfferDetailForm: FC<AffiliateOfferDetailFormProps> = ({ request }) => {
    const defaultValues = {
        title: (request.offer as OfferData)?.title || "",
        email: request.user?.email || "",
        status: request.status || "",
        // commission_group_id: request.commission_group_id || "",
        created_at: dayjs(request.created_at),
        updated_at: dayjs(request.updated_at),
    };

    return (
        <GeneralFormProvider<AffiliateOfferFormData> schema={schema} defaultValues={defaultValues}>
            <AffiliateOfferDetailFormContent request={request} />
        </GeneralFormProvider>
    );
};
